import { useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';

import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

export const CreateModelModal = ({ showModal, setShowModal, refreshData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await customAxios.get(
          `${GlobalVariables.getURL()}brands/`,
          HEADERS,
        );
        setBrands(response.data.data || response.data || []);
      } catch (error) {
        getToast({
          status: 'error',
          title: error.response?.data?.message || 'Error',
        });
      }
    };
    if (showModal) fetchBrands();
  }, [showModal]);

  const handleClose = () => {
    setShowModal(false);
    setName('');
    setBrand(null);
    refreshData();
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await customAxios.post(
        `${GlobalVariables.getURL()}models/`,
        { name, brand_id: brand.id },
        HEADERS,
      );
      if (response.status >= 200 && response.status < 300) {
        getToast({
          status: 'success',
          title: 'Modelo creado exitosamente en la base de datos.',
        });
        handleClose();
      }
    } catch (error) {
      console.log('Error creating model:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={showModal} maxWidth='sm' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Nuevo modelo
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{ position: 'absolute', right: 20, top: 20, width: 40, height: 40 }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id='create-model-form' onSubmit={handleSubmit}>
          <TextField
            required
            fullWidth
            disabled={isLoading}
            label='Nombre'
            placeholder='Nombre...'
            value={name}
            onChange={(event) => setName(event.target.value)}
            sx={{ mb: 2 }}
          />
          <Autocomplete
            options={brands}
            value={brand}
            disabled={isLoading}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name || ''}
            onChange={(event, value) => setBrand(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                label='Marca'
                placeholder='Marca...'
              />
            )}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          form='create-model-form'
          type='submit'
          disabled={isLoading || !brand}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
